"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_svg_1 = require("react-native-svg");
const images_1 = require("../../../../assets/images");
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const constants_1 = require("../../../../constants");
const helpler_1 = require("../../../../utils/helpler");
const scale_1 = require("../../../../utils/scale");
const ModalPickInheritUser_1 = __importDefault(require("./ModalPickInheritUser"));
const InheritUser = ({ editable, defaultValue, isShowGuide, isArticle, onChange }) => {
    const [guideVisible, setGuideVisible] = (0, react_1.useState)(isShowGuide);
    const [modalVisible, setModalVisible] = (0, react_1.useState)(false);
    const [selected, setSelected] = (0, react_1.useState)(defaultValue);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.View, { style: styles.inheritUserContainer },
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.inheritUserTitle }, editable ? '継承元の先輩' : `継承元の${isArticle ? "記事" : '自分史'}を作成した先輩`),
            react_1.default.createElement(react_native_1.View, { style: [
                    styles.inheritUserButton,
                    !editable && {
                        backgroundColor: 'transparent',
                        borderColor: 'transparent',
                        paddingHorizontal: 0
                    }
                ] },
                react_1.default.createElement(react_native_1.View, { style: styles.userItem }, selected ?
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_native_1.Image, { source: !!selected.thumbnail_url ?
                                { uri: selected.thumbnail_url }
                                :
                                    images_1.images.AvatarDefaul, style: styles.avatar }),
                        react_1.default.createElement(react_native_1.View, { style: styles.info },
                            react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, weight: '600', style: styles.nickname }, selected.nickname || constants_1.DEFAULT_NAME),
                            react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles.userHandle },
                                "@",
                                selected.user_handle)))
                    :
                        react_1.default.createElement(CustomText_1.default, { style: styles.inheritUserLabel }, "\u6307\u5B9A\u306A\u3057")),
                editable ? (react_1.default.createElement(CustomText_1.default, { style: [styles.inheritUserLabel, { color: '#007AFF' }], onPress: () => setModalVisible(true) }, selected ? '変更' : '指定する'))
                    :
                        react_1.default.createElement(react_native_1.View, null))),
        react_1.default.createElement(ModalPickInheritUser_1.default, { isVisible: modalVisible, onClose: () => setModalVisible(false), onSelected: (user) => {
                setSelected(user);
                setModalVisible(false);
                onChange(user);
            } }),
        react_1.default.createElement(react_native_1.Modal, { statusBarTranslucent: true, visible: guideVisible, animationType: "fade", transparent: true, onRequestClose: () => setGuideVisible(false), onShow: () => {
                helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
            }, onDismiss: () => {
                helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
            } },
            react_1.default.createElement(react_native_1.View, { style: styles.modalContainer },
                react_1.default.createElement(react_native_1.View, { style: styles.modalBody },
                    react_1.default.createElement(react_native_1.View, { style: { paddingHorizontal: (0, scale_1.scale)(8) } },
                        react_1.default.createElement(react_native_1.View, { style: styles.modalView1 },
                            react_1.default.createElement(CustomText_1.default, { weight: '600', style: styles.modalViewTitle }, "\u7D99\u627F\u5143\u306E\u5148\u8F29"),
                            react_1.default.createElement(CustomText_1.default, { style: styles.modalViewDescription }, `ここでは、先輩ユーザー自体を継承元として選び、あなた独自の${isArticle ? "記事" : '自分史'}を作成することができます。\n\nもし特定の${isArticle ? "記事" : '自分史'}からインスピレーションを得て、あなたの${isArticle ? "記事" : '自分史'}を作成したい場合は、お手数ですが、対象${isArticle ? "記事" : '自分史'}ページの「継承する」ボタンをタップして、${isArticle ? "記事" : '自分史'}の作成に進んでください。`),
                            react_1.default.createElement(CustomText_1.default, { onPress: () => setGuideVisible(false), style: styles.modalViewBtn }, "\u4E86\u89E3\u3057\u307E\u3057\u305F"),
                            react_1.default.createElement(react_native_1.View, { style: styles.modalViewAbsolute },
                                react_1.default.createElement(react_native_svg_1.Svg, { width: (0, scale_1.scale)(24), height: (0, scale_1.scale)(24), viewBox: "0 0 19 16", fill: "none" },
                                    react_1.default.createElement(react_native_svg_1.Path, { d: "M11.2321 15C10.4623 16.3333 8.53775 16.3333 7.76795 15L0.839748 3C0.0699477 1.66667 1.0322 -1.78935e-06 2.5718 -1.65476e-06L16.4282 -4.43391e-07C17.9678 -3.08794e-07 18.9301 1.66667 18.1603 3L11.2321 15Z", fill: "white" }))))),
                    react_1.default.createElement(react_native_1.View, { style: styles.modalView2 },
                        react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.inheritUserTitle }, "\u7D99\u627F\u5143\u306E\u5148\u8F29"),
                        react_1.default.createElement(react_native_1.View, { style: styles.inheritUserButton },
                            react_1.default.createElement(react_native_1.View, { style: styles.userItem },
                                react_1.default.createElement(CustomText_1.default, { style: styles.inheritUserLabel }, "\u6307\u5B9A\u306A\u3057")),
                            react_1.default.createElement(CustomText_1.default, { style: [styles.inheritUserLabel, { color: '#007AFF' }] }, "\u6307\u5B9A\u3059\u308B"))))))));
};
exports.default = InheritUser;
const styles = react_native_1.StyleSheet.create({
    inheritUserContainer: {
        position: 'absolute',
        bottom: (0, scale_1.verticalScale)(83),
        paddingHorizontal: (0, scale_1.scale)(16),
        left: 0,
        right: 0,
        zIndex: 1,
    },
    inheritUserTitle: {
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#545454',
    },
    inheritUserButton: {
        width: '100%',
        height: (0, scale_1.verticalScale)(47),
        backgroundColor: '#FEFEFE',
        borderWidth: (0, scale_1.scale)(1),
        borderColor: '#C8C8C8',
        borderRadius: (0, scale_1.scale)(4),
        flexDirection: 'row',
        alignItems: 'center',
        padding: (0, scale_1.scale)(12),
        // paddingVertical: scale(8),
        marginTop: (0, scale_1.scale)(8),
    },
    inheritUserLabel: {
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#292A33',
    },
    userItem: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    avatar: {
        width: (0, scale_1.verticalScale)(40),
        height: (0, scale_1.verticalScale)(40),
        borderRadius: 99,
    },
    info: {
        flex: 1,
        justifyContent: 'space-between',
        marginHorizontal: (0, scale_1.scale)(8),
    },
    nickname: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33',
    },
    userHandle: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: '#888888',
    },
    modalContainer: {
        flex: 1,
        backgroundColor: '#000000B2',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingBottom: (0, scale_1.verticalScale)(83) - (0, scale_1.scale)(8),
    },
    modalBody: {
        paddingHorizontal: (0, scale_1.scale)(8),
        width: scale_1.width
    },
    modalView1: {
        width: '100%',
        padding: (0, scale_1.scale)(12),
        backgroundColor: '#FEFEFE',
        borderRadius: (0, scale_1.scale)(4)
    },
    modalView2: {
        width: '100%',
        padding: (0, scale_1.scale)(8),
        backgroundColor: '#FEFEFE',
        borderRadius: (0, scale_1.scale)(4),
        marginTop: (0, scale_1.scale)(23),
    },
    modalViewTitle: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33'
    },
    modalViewDescription: {
        marginTop: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33'
    },
    modalViewBtn: {
        alignSelf: 'flex-end',
        marginTop: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#007AFF'
    },
    modalViewAbsolute: {
        position: 'absolute',
        bottom: -(0, scale_1.scale)(15),
        left: 0,
        right: 0,
        alignItems: 'center',
    }
});
